import React from "react";
import "./Navbar.css";

const styles = {
  navbarStyle: {
    background: "#FFD90F",
    color: "black",
    fontSize: 30,
    fontWeight: "bold"
  }
};

const Navbar = props => (
  <nav style={styles.navbarStyle} className="navbar">
    <p>Simpsons Clicky Game</p>
    <p
      className={
        props.message.indexOf("incorrectly") !== -1
          ? "incorrect"
          : props.message.indexOf("correctly") !== -1
            ? "correct"
            : "normal"
      }
    >
      {props.message}
    </p>
    <p>
      Score: {props.currentScore} | Top Score: {props.topScore}
    </p>
  </nav>
);

export default Navbar;



// WEBPACK FOOTER //
// ./src/components/Navbar/Navbar.js